import type { SingleValue } from 'react-select';

import { FormField, Select } from '@revelio/ui';

import type { SelectOption } from './impersonationModal.utils';
import styles from './impersonationOverrides.module.css';

interface ImpersonationClientGroupQuickSelectProps {
  clientSelectOptions: SelectOption<string>[];
  selectedClientOption: SelectOption<string> | undefined;
  onSelectClientGroup: (clientName: string | undefined) => void;
}

export function ImpersonationClientGroupQuickSelect({
  clientSelectOptions,
  selectedClientOption,
  onSelectClientGroup,
}: ImpersonationClientGroupQuickSelectProps) {
  return (
    <FormField
      label="Client Group"
      htmlFor="impersonation-quick-client-group"
      className={styles.stackedRow}
      supportingText="Quickly view the dashboard with a client group’s settings."
    >
      <Select<SelectOption<string>, false>
        inputId="impersonation-quick-client-group"
        options={clientSelectOptions}
        value={selectedClientOption ?? null}
        placeholder="Select a client group to view..."
        onChange={(selected: SingleValue<SelectOption<string>>) =>
          onSelectClientGroup(selected?.value)
        }
        isClearable
        data-testid="quick-client-group-select"
      />
    </FormField>
  );
}
